import { render } from "./PriceRangeSelector.vue?vue&type=template&id=2efe92f8&scoped=true"
import script from "./PriceRangeSelector.vue?vue&type=script&lang=js"
export * from "./PriceRangeSelector.vue?vue&type=script&lang=js"

import "./PriceRangeSelector.vue?vue&type=style&index=0&id=2efe92f8&lang=scss&scoped=true"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efe92f8"]])

export default __exports__